<button mat-icon-button [matMenuTriggerFor]="langMenu">
    <mat-icon>language</mat-icon>
</button>

<mat-menu [xPosition]="'before'" #langMenu="matMenu">
    <button *ngFor="let lang of languages; trackBy: trackByFn"
        mat-menu-item
        (click)="setActiveLanguage(lang.id)">
        <span class="flex items-center">
            <span [class.font-semibold]="activeLanguage.id === lang.id">{{ lang.label }}</span>
        </span>
    </button>
</mat-menu>
